var map = {
	"./afghanistan.1.png": "0a4a",
	"./afghanistan.png": "26e7",
	"./america.1.png": "4168",
	"./america.png": "82305",
	"./attachment.png": "4421",
	"./date-time.png": "09b4",
	"./date.png": "11d4",
	"./delete (1).png": "c909",
	"./description.png": "efd3",
	"./excel.png": "444c",
	"./grid-selection.png": "8b18",
	"./heading.png": "2f99",
	"./large-text.png": "810a",
	"./list-selection-2.png": "de7c",
	"./list-selection.png": "d939",
	"./logo.1.png": "9077",
	"./logo.png": "cf05",
	"./maps-and-flags.png": "04c7",
	"./mockup.png": "e79e",
	"./mockup5.png": "2fc5",
	"./mockup6.png": "0b83",
	"./multiple-geolocation.png": "9410",
	"./multiple-option-2.png": "bd0b",
	"./multiple-option.png": "1e73",
	"./nepaLogo.png": "e905",
	"./odf-file-format.png": "6efe",
	"./odt-file-format.png": "7b26",
	"./percent.png": "5263",
	"./profile.png": "c3e7",
	"./single-geolocation.png": "3f5d",
	"./single-option-2.png": "ebd0",
	"./single-option.png": "5038f",
	"./small-text.png": "baf7",
	"./word.png": "ccfd",
	"./yes-no.png": "b1fe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";